<script setup lang="ts">
import { computed, ref } from "vue";

import { useBrandStore } from "@/stores/brand-store";

const lenses = computed(() => useBrandStore().lenses);
const selectedLens = ref(useBrandStore().selectedLens.code);

function onLensChange() {
  const lens = lenses.value.find((l) => l.code === selectedLens.value);

  if (!lens) {
    console.error("No lens was selected");
  } else {
    useBrandStore().selectLens(lens);
  }
}
</script>
<template>
  <div v-if="lenses.length > 1" tabindex="0" class="tw-flex tw-items-center tw-justify-start tw-gap-1.5 tw-px-2">
    Lens:
    <select
      v-model="selectedLens"
      class="tw-min-w-0 tw-truncate tw-rounded-md tw-border tw-border-black/70 tw-p-1 tw-text-black"
      aria-label="Select lens"
      @change="onLensChange"
    >
      <option v-for="l in lenses" :key="l.code" :value="l.code">
        {{ l.name }}
      </option>
    </select>
  </div>
</template>
